<template>
  <div class='search-term-card'>
    <div class='header'>
      Search terms:
    </div>
    <div id="search-terms" class="scroll ver">
      <searchTerm
        v-for="st in config.searchTerms"
        :st='st'
        :key='st.obfuscatedId'
        @click.native='showSearchTerm(st.text)'
        class='search-terms-item' />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import searchTerm from './search_term'

export default {
  name: 'SearchTermsList',
  components: { searchTerm },
  computed: mapState(['config', 'searchTerm']),
  methods: mapActions(['showSearchTerm'])
}

</script>
